/**
 * Matomo: configuration comes from `public/config/config.json` at runtime
 * (same pattern as other VUE_APP_* keys). If URL or site id is missing, nothing runs.
 *
 * SPA: the tracker script is injected after config loads; `initMatomoRouterTracking`
 * sends a pageview on each vue-router navigation.
 */

let matomoActive = false;
let suppressFirstRouterPageview = false;

const normalizeTrackerBaseUrl = (url) => {
  const u = String(url).trim();
  if (!u) return '';
  return u.endsWith('/') ? u : `${u}/`;
};

/**
 * Bootstraps Matomo from application config (e.g. config.json).
 * Call once after configuration is available, before mounting the Vue app.
 * @param {Record<string, unknown>} config
 */
export const initMatomoFromConfig = (url, siteIdentifier) => {
  matomoActive = false;
  suppressFirstRouterPageview = false;

  if (typeof window === 'undefined') {
    return;
  }

  const rawUrl = url;
  const rawSiteId = siteIdentifier;
  const baseUrl = typeof rawUrl === 'string' ? normalizeTrackerBaseUrl(rawUrl) : '';
  const siteId = rawSiteId !== undefined && rawSiteId !== null ? String(rawSiteId).trim() : '';

  if (!baseUrl || !siteId) {
    return;
  }

  const _paq = (window._paq = window._paq || []);
  /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
  _paq.push(['setTrackerUrl', `${baseUrl}matomo.php`]);
  _paq.push(['setSiteId', siteId]);
  _paq.push(['trackPageView']);
  _paq.push(['enableLinkTracking']);

  const d = document;
  const g = d.createElement('script');
  const s = d.getElementsByTagName('script')[0];
  g.async = true;
  g.src = `${baseUrl}matomo.js`;
  if (s && s.parentNode) {
    s.parentNode.insertBefore(g, s);
  } else {
    d.head.appendChild(g);
  }

  matomoActive = true;
  suppressFirstRouterPageview = true;
};

export const initMatomoRouterTracking = (router) => {
  if (!matomoActive || !router || typeof window === 'undefined' || !Array.isArray(window._paq)) {
    return;
  }

  router.afterEach((to, from) => {
    if (suppressFirstRouterPageview) {
      suppressFirstRouterPageview = false;
      return;
    }

    window._paq.push(['setReferrerUrl', window.location.origin + (from.fullPath || '')]);
    window._paq.push(['setCustomUrl', window.location.href.toLowerCase()]);
    window._paq.push(['setDocumentTitle', document.title]);
    window._paq.push(['deleteCustomVariables', 'page']);
    window._paq.push(['trackPageView']);
  });
};
